import { EditableCardType, ScrubAddressModalType } from '@app/redux/scrubbedAddress';

export enum ProfileTab {
  ResidentialAccount = 'ResidentialAccount',
  ResidentialContact = 'ResidentialContact',
  SMBAccount = 'SMBAccount',
  SMBBusiness = 'SMBBusiness',
  ProfileTab = 'ProfileTab',
  InternetPlan = 'InternetPlan',
}

export type NavBarProps = {
  currentTab: ProfileTab;
  handleTabClick: (tab: ProfileTab) => void;
};

export interface CommonProfileProps {
  setCloseAfterReload: (value: boolean) => void;
  setEditingCard: (value: EditableCardType) => void;
  setRestrictSwitchTabs: (value: boolean) => void;
  setShowModal: (value: ScrubAddressModalType | null) => void;
}

export interface EditableCardProps {
  closeAfterReload: boolean;
  currentTab: ProfileTab;
  editingCard: EditableCardType;
  id: string;
  loading: boolean;
  setCloseAfterReload: (close: boolean) => void;
  setEditingCard: (type: EditableCardType) => void;
  setRestrictSwitchTabs: (restrict: boolean) => void;
  setShowModal: (type: ScrubAddressModalType | null) => void;
  text?: string;
  type: EditableCardType;
}
